const styles = {
    form: () => ({
        backgroundColor: '#ffffff',
        padding: "10px 35px 10px 32px"
    }),
    majorRowDiv: () => ({
        paddingLeft: 32,
        paddingRight: 35,
        paddingTop: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // paddingBottom: 40
    }),
    filterRowDiv: (isLastRow) => ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: isLastRow && 'flex-end'
    }),
    formLabel: () => ({
        color: '#a1a1b5',
        letterSpacing: 1.5
    }),
    inputSize: () => ({
        width: 250
    }),
    button: () => ({
        fontSize: 12,
        fontWeight: '600',
        textTransform: 'uppercase',
    })
}

export default styles